//colors
const BORDER_COLOR = ({ palette }) => palette.greyscale[200]; // "#D8E4F0"

// sizes - based on https://www.figma.com/file/1mQZLEypWKtmaOBckl2MNN/4.4.0-IL%2BCDC-Automation?type=design&node-id=4278-32148&mode=design&t=PR2oGGfiaZ3AoJMT-4
const CONTAINER_HEIGHT = "700px";
const CONTAINER_HEIGHT_COMPACT = "480px";
const HEADING_HEIGHT = "54px";
const LEFT_SIDEBAR_WIDTH = "240px";
const LEFT_SIDEBAR_WIDTH_COMPACT = "140px";
const LEFT_SIDEBAR_COLLAPSED_WIDTH = "50px";
const CLOSED_SIDEBAR_WIDTH = "0px";

export const styles = {
    stFrameContainer: {
        display: "flex",
        flexDirection: "column",
        height: CONTAINER_HEIGHT,
        borderTopLeftRadius: "8px",
        backgroundColor: ({ palette }) => palette.common.white
    },
    stFrameContainerCompact: {
        height: CONTAINER_HEIGHT_COMPACT
    },
    stLeftSection: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1
    },
    stMainFrameElement: {
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        height: "100%",
        overflow: "auto"
    },
    stHeadingElement: {
        borderBottom: 1,
        borderColor: BORDER_COLOR
    },
    stChildContainer: {
        display: "flex",
        flexGrow: 1,
        flexDirection: "row",
        height: `calc(100% - ${HEADING_HEIGHT})`,
        overflow: "auto"
    },
    stChildContainerCompact: {
        border: 1,
        borderColor: BORDER_COLOR,
        borderRadius: "8px"
    },
    stChildleftSidebarContainer: {
        overflow: "auto"
    },
    stChildLeftSidebar: {
        borderRight: 1,
        borderColor: BORDER_COLOR,
        width: LEFT_SIDEBAR_WIDTH
    },
    stChildLeftSidebarCompact: {
        borderRight: 1,
        borderColor: BORDER_COLOR,
        width: LEFT_SIDEBAR_WIDTH_COMPACT,
        flexShrink: 0
    },
    stChildLeftSidebarClosed: {
        borderRight: 1,
        borderColor: BORDER_COLOR,
        width: LEFT_SIDEBAR_COLLAPSED_WIDTH
    },
    stChildMainSection: {
        flexGrow: 1,
        maxWidth: "70%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        minWidth: 0
    },
    stChildMainSectionCompact: {
        flexGrow: 1,
        height: "100%",
        overflow: "scroll",
        display: "flex",
        flexDirection: "column",
        minWidth: 0
    },
    childSectionTitleContainer: {
        borderBottom: 1,
        borderColor: BORDER_COLOR
    },
    iconWrapper: {
        "& svg": {
            width: "20px",
            height: "20px",
            color: "additional.white"
        }
    },
    expanded: {
        transform: "rotate(180deg)"
    },
    stHeadingTitle: {
        fontFamily: "Inter"
    }
};

export const sizes = {
    LEFT_SIDEBAR_WIDTH,
    CLOSED_SIDEBAR_WIDTH
};
